import PreviewFile from '@/views/consultations/en-cours/consultation-sections/preview-file'
import $ from 'jquery'

export default {
    name: 'historique-section-contents',
    components: {
        PreviewFile
    },
    props: {
        historique: Object,
        evolution_id: Number
    },
    data() {
        return {
            prev_info: {
                file_name: '',
                label: ''
            },
            prev_toggler: 0,
            slug: ""
        }
    },

    computed: {

    },

    mounted() {
        console.log("Histo Sect; ",this.historique);
        
    },

    methods: {
        previewFile(data) {
            this.prev_toggler = (this.prev_toggler == 0)?1:0

            this.prev_info = {
                file_name: data.contenu,
                label: data.libelle
            }

            const timestamp = new Date().getTime();
            this.slug = this.historique.data_type+timestamp

            setTimeout(() => {
                $('.preview-file-'+this.evolution_id+this.slug).modal('show')
            }, 500);
        },
    }
}